// extracted by mini-css-extract-plugin
module.exports =  {"group":"_84ff5fbbc9--group--bH6Pm","logo":"_84ff5fbbc9--logo--Xr3DR","tomobile":"_84ff5fbbc9--tomobile--ZJ1cp","age":"_84ff5fbbc9--age--xy6Ye"};